import {connect} from "react-redux";
import SearchBarComponent from "../components/SearchBarComponent";
import {
    clearSearchFiltersAction,
    setSearchLocationAction,
    setSearchQueryAction,
    toggleSearchFiltersAction
} from "../actions";
import {searchSelector} from "../selectors";
import {pushSearch} from "../middlewares";

const mapStateToProps = (state, props) => {
    const search = searchSelector(state);

    return {
        query: search.query,
        location: search.geo.address,
        filtersEnabled: search.filters.enabled
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleFilter: () => {
            dispatch(toggleSearchFiltersAction());
        },
        changeQuery: (e: React.FormEvent<HTMLInputElement>) => {
            dispatch(setSearchQueryAction({query: e.currentTarget.value}));
        },
        changeLocation: (e: React.FormEvent<HTMLInputElement>) => {
            dispatch(setSearchLocationAction({location: e.currentTarget.value}));
        },
        search: () => {
            dispatch(pushSearch());
        },
        clear: () => {
            dispatch(clearSearchFiltersAction());
        }
    }
};

const SearchBarContainer = connect(mapStateToProps, mapDispatchToProps)(SearchBarComponent);
export default SearchBarContainer;


// WEBPACK FOOTER //
// ./app/client/search/containers/SearchBarContainer.tsx